import moment from 'moment';

export default function groupByDate (events, dateProp = 'date') {
    events = events && events.length ? events : [];

    var groups = {};
    events.forEach(event => {        
        var dateString = moment(event[dateProp]).format("YYYY-MM-DD");
        groups[dateString] = groups[dateString] || [];
        groups[dateString].push(event);
    });
    var dates = Object.keys(groups).sort((a, b) => {
        return moment(b).diff(moment(a), 'days');
    });
    return dates.map(dateString => {
        return groups[dateString];
    });
};


// WEBPACK FOOTER //
// ./app/utils/groupByDate.js